'use strict';

var React = require('react');
var mui = require('material-ui');
var SvgIcon = mui.SvgIcon;

var createClass = require('create-react-class');

var MapsPlace = createClass({
  displayName: 'MapsPlace',

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
    );
  }

});

module.exports = MapsPlace;


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/react-material-icons/icons/maps/place.js
// module id = 1053
// module chunks = 1